<template>
    <div id="app">
        <!-- 登录页或者首页 -->
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: "app",
    created: async function() {
        let res = await  this.$axios.get("/user/getCurrentUser").catch(err => {return {}});
        console.log(res);
        const myUserInfo = res.code === 200 ? res.data: null;
        if (!myUserInfo) {
            this.$store.commit("updateUserInfo", {});
            sessionStorage.removeItem("userInfo");
        } else {
            this.$store.commit("updateUserInfo", res.data)
            sessionStorage.setItem("userInfo", JSON.stringify(res.data));
        }
        if(this.$router.currentRoute.meta.requireAuth&&!myUserInfo){
            this.$router.replace('/home');
        }
        this.$axios.get('/openApi/getSystemConfig').then(res => {
            if (res.code === 200) {
                this.$store.commit('updateSystemConfig', res.data);
            } else {
                this.$alert(res.errMsg, "错误提示")
            }
        }).catch(err => {});
    },
    computed: {

    },
};
</script>

<style>
* {
    margin: 0;
    padding: 0;
}

html,
body,
#app,
.wrapper {
    width: 100%;
}

body {
    font-family: '微软雅黑','PingFang SC', "Helvetica Neue", Helvetica, "microsoft yahei", arial, STHeiTi, sans-serif;
}

</style>
